import React from 'react';
import { debounce } from 'lodash';
import NextImage from 'next/image';
import classNames from 'classnames';
import { Flex } from '@radix-ui/themes';
import { Skeleton } from '@/app/components/ui/skeleton';

interface Props {
  loading: boolean;
  currentIndex: number;
  setCurrentIndex: (index: number) => void;
  images: any[];
}

const ImagePanel = ({ loading, currentIndex, setCurrentIndex, images }: Props) => {
  const debouncedSetCurrentIndex = debounce((index: number) => setCurrentIndex(index), 5);

  if (loading) {
    return (<Flex
      className={`px-1 mt-4 w-full h-[64px] overflow-x-scroll hide-scrollbar`} gap="1">
      {[1, 2, 3].map((num) => (
        <Skeleton
          key={num}
          className='h-[50px] w-[50px]'
        />
      ))}
    </Flex>)
  }

  if (images.length > 0) {
    return (
      <Flex
        className={`px-1 pt-1 mt-1 bg-white w-full h-[66px] overflow-x-scroll hide-scrollbar space-x-1`}
      >
        {images.map((image, index) => {
          return (
            <Flex
              key={index}
              className={classNames(
                `relative flex-shrink-0 group overflow-hidden rounded-md`,
                `h-[50px] w-[50px]`
              )}
              onMouseEnter={() => debouncedSetCurrentIndex(index)}>
              <NextImage
                key={index}
                src={image.preview}
                fill
                alt="Thumbnail"
                priority
                unoptimized
                style={{ objectFit: "cover" }}
                quality="30"
              />
              <Flex className={
                classNames(
                  `absolute top-0 left-0 right-0 bottom-0 bg-black`,
                  `bg-opacity-0 group-hover:bg-opacity-30`,
                  index === currentIndex &&
                  `bg-opacity-30 transition-opacity duration-300`
                )}
              />
            </Flex>
          )
        })}
      </Flex >
    )
  } else {
    // Don't display any panel if there aren't any images 
    // for the current lot
    return null;
  }
}

export default ImagePanel
